import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import {takeUntil} from 'rxjs/operators';
import {componentDestroyed} from '@w11k/ngx-componentdestroyed';

import {RoleService} from '../role.service';
import {Role} from '../role.model';

@Component({
  selector: 'app-role-delete-dialog',
  templateUrl: './role-delete-dialog.component.html',
  styleUrls: ['../role.component.css']
})
export class RoleDeleteDialogComponent implements OnInit, OnDestroy {
  role: Role;
  errorMessage: string;
  constructor(private roleService: RoleService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private snackBar: MatSnackBar,
              public dialogRef: MatDialogRef<RoleDeleteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: Role) {
    this.role = data;
  }

  ngOnInit() {
  }
  ngOnDestroy(): void {
  }

  delete() {
    this.errorMessage = '';
    this.roleService.deleteRole(this.role.id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(response => this.onSaveSuccess(response), (response) => this.onSaveError(response));
  }

  onSaveSuccess(result) {
    this.dialogRef.close('deleted');
  }

  onSaveError(response) {
    this.errorMessage = response;
  }

  cancel(): void {
    this.dialogRef.close('canceled');
  }
}
